import { render, staticRenderFns } from "./joinUs.vue?vue&type=template&id=5593fad8&scoped=true&"
import script from "./joinUs.vue?vue&type=script&lang=js&"
export * from "./joinUs.vue?vue&type=script&lang=js&"
import style0 from "./joinUs.vue?vue&type=style&index=0&id=5593fad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5593fad8",
  null
  
)

export default component.exports